/**
 *  @class
 *  @function FacetsToggle
 */
if (!customElements.get('facets-toggle')) {
  class FacetsToggle extends HTMLElement {
    connectedCallback() {
      this.drawer = document.getElementById('Facet-Drawer');

      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (OverlayManager.isOpen(this.drawer)) {
          OverlayManager.close(this.drawer);
        } else {
          OverlayManager.open(this.drawer);
        }
      });

      setTimeout(() => {
        window.dispatchEvent(new Event('resize.resize-select'));
      }, 10);
    }
  }
  customElements.define('facets-toggle', FacetsToggle);
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    /* ZUMO fix: the search empty state (sections/main-search.liquid) has no .collection
       element, so guard instead of throwing and aborting the whole re-render. */
    const gridContainer = document.getElementById('ProductGridContainer');
    const loadingTarget = gridContainer ? gridContainer.querySelector('.collection') : null;
    if (loadingTarget) loadingTarget.classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    FacetFiltersForm.publishFacetUpdate(searchParams);
  }

  // shopify:collection:update / shopify:search:update — filters or sort changed
  static publishFacetUpdate(searchParams) {
    const SE = window.Shopify && window.Shopify.StandardEvents;
    if (!SE) return;
    const params = new URLSearchParams(searchParams);

    if (theme.settings.collection_id) {
      publishStandardEvent('CollectionUpdateEvent', {
        collection: { id: theme.settings.collection_id },
        filters: SE.CollectionUpdateEvent.parseProductFilters(params),
        sortKey: SE.CollectionUpdateEvent.getSortKey(params)
      });
    } else if (window.location.pathname.indexOf(theme.routes.search_url) !== -1) {
      publishStandardEvent('SearchUpdateEvent', {
        searchTerm: params.get('q') || new URLSearchParams(window.location.search).get('q') || '',
        filters: SE.SearchUpdateEvent.parseProductFilters(params),
        sortKey: SE.SearchUpdateEvent.getSortKey(params)
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        withViewTransition(() => {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    withViewTransition(() => {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    for (var item of container) {
      if (countHtml) {
        item.innerHTML = countHtml.innerHTML;
      }
      /* ZUMO fix: always clear the spinner. #ProductCount lives in facets-bar, which
         sections/main-search.liquid renders only when there ARE results, so filtering a
         search down to zero left .thb-filter-count stuck in .loading forever
         (.thb-filter-count.loading .facets__label {opacity:0} in facets.css hides the
         count). The correct text is written by renderAdditionalElements just before this. */
      item.classList.remove('loading');
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row, #FacetFiltersForm-bar collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      /* ZUMO fix: only the parsed side was guarded. On search, .active-facets lives in
         facets-bar, which sections/main-search.liquid renders only when there ARE results,
         so in the "no results" state it is absent from the document while the freshly
         fetched HTML has it. Writing to null threw here, inside renderFilters, i.e. BEFORE
         renderProductGridContainer ran - so the grid never came back. The correct markup
         arrives anyway with the #ProductGridContainer innerHTML a moment later. */
      const target = document.querySelector(selector);
      if (!target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    /* ZUMO fix: the search empty state renders no #product-grid, so after filtering a search
       down to zero results every further filter/sort change threw here and stopped refetching.
       Fall back to the section wrapper id, which is 'shopify-section-' + section.id. */
    const grid = document.getElementById('product-grid');
    let sectionId = grid ? grid.dataset.id : null;
    if (!sectionId) {
      const wrapper = document.getElementById('ProductGridContainer');
      const section = wrapper ? wrapper.closest('.shopify-section') : null;
      if (section && section.id) sectionId = section.id.replace('shopify-section-', '');
    }
    if (!sectionId) return [];
    return [
      {
        section: sectionId,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

(function () {
  const updateShift = (label) => {
    const content = label.querySelector('.facet-tooltip__content');
    if (!content) return;
    label.style.setProperty('--tooltip-shift', '0px');
    const rect = content.getBoundingClientRect();
    const gutter = 8;
    const vw = document.documentElement.clientWidth;
    let shift = 0;
    if (rect.left < gutter) {
      shift = Math.round(gutter - rect.left);
    } else if (rect.right > vw - gutter) {
      shift = Math.round(vw - gutter - rect.right);
    }
    label.style.setProperty('--tooltip-shift', shift + 'px');
  };

  document.addEventListener('mouseover', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label || label._tooltipHovered) return;
    label._tooltipHovered = true;
    updateShift(label);
  });

  document.addEventListener('mouseout', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label) return;
    if (!label.contains(e.relatedTarget)) {
      label._tooltipHovered = false;
    }
  });
})();
